import React from "react";
import { connect } from "react-redux";
import { Button } from "../../atoms/Buttons/Base";
import { CloseIcon } from "../../atoms/Icons/CloseIcon";
import { InfoIcon } from "../../atoms/Icons/InfoIcon";
import { Text } from "../../atoms/Text/Text";
import { isServer } from "../../../utils";
import { LocalStorageService } from "../../services/LocalStorage";
import { Analytics } from "../../services/Analytics/Analytics";
import styles from "./NotificationBanner.css";
import { Game } from "../../models/Game";
import {
  NotificationBannerService,
  NotificationBannerEvent,
} from "../../services/NotificationBannerService";

type NotificationBannerProps = {
  notificationBanner: NotificationBannerEvent[];
  isTheaterMode: boolean;
  game?: Game;
};

interface RootState {
  notificationBanner: NotificationBannerEvent[];
  isTheaterMode: boolean;
}

export class NotificationBannerDumb extends React.PureComponent<NotificationBannerProps> {
  state = {
    currentNotificationBanner: this.getCurrentNotificationBanner(),
  };
  getCurrentNotificationBanner() {
    const { notificationBanner, game } = this.props;
    return NotificationBannerService.getEventByGame(
      notificationBanner,
      game.slug
    );
  }

  onCloseClick = () => {
    LocalStorageService.setItem(this.state.currentNotificationBanner.key, true);
    this.setState({
      currentNotificationBanner: {
        ...this.state.currentNotificationBanner,
        showNotification: false,
      },
    });
  };

  trackClick() {
    const { isTheaterMode } = this.props;
    Analytics.trackEvent(
      Analytics.general.yellowBanner(
        this.state.currentNotificationBanner.key,
        isTheaterMode
      )
    );
  }

  componentDidMount() {
    if (isServer) return;

    document.querySelectorAll('[class*="messageText"] > a').forEach((item) => {
      item.addEventListener("click", () => this.trackClick());
    });
  }

  componentDidUpdate(prevProps: Readonly<NotificationBannerProps>) {
    if (prevProps.game.slug !== this.props.game.slug) {
      this.setState({
        currentNotificationBanner: this.getCurrentNotificationBanner(),
      });
    }
  }

  render() {
    const banner = this.state.currentNotificationBanner;
    if (!banner.showNotification) {
      return null;
    }

    return (
      <Container>
        <InfoIcon aria-hidden="true" className={styles.infoIconItem} />
        <MessageContainer>
          <MessageText
            bold={true}
            size="md"
            isDangerously={true}
            content={banner.text}
          />
        </MessageContainer>
        <CloseButton
          onClick={this.onCloseClick}
          aria-label="user notification close button"
        >
          <CloseIcon aria-hidden="true" />
        </CloseButton>
      </Container>
    );
  }
}
export const NotificationBanner = connect((state: RootState) => ({
  notificationBanner: state.notificationBanner,
  isTheaterMode: state.isTheaterMode,
}))(NotificationBannerDumb);

const Container = (props: any) => (
  <div className={styles.container} {...props} />
);
const MessageContainer = (props: any) => (
  <div className={styles.messageContainer} {...props} />
);
const MessageText = (props: any) => (
  <Text className={styles.messageText} {...props} />
);
const CloseButton = (props: any) => (
  <Button className={styles.closeButton} {...props} />
);
